import React, { useEffect, useState } from 'react';
import { List, ListItem, Title } from '@icarros/ids-react';

import { useAdContext } from '../../../store/contexts/ad';
import { ListItemModifier, OpenEditTitleWrapper, OpenEditWrapper } from './style';
import { useAd } from '../../../store/hooks/useAd';
import { Loading } from '../../../components/Loading';
import { SaveFormContent } from './SaveFormContent';
import { useQuery } from '@tanstack/react-query';
import { getDescriptionItems } from '../../../services/Edits.service';
import { GET_DESCRIPTION_ITEMS } from '../../../queries';

export function DifferentialsForm(): JSX.Element {
  const { setCurrentContent, loading } = useAd();
  const { currentAd, setValueIsDifferentFromCurrent } = useAdContext();
  const { itensDescricao } = currentAd?.veiculo || {};
  const [selectedSwitches, setSelectedSwitches] = useState<number[]>();

  const { data, isInitialLoading } = useQuery({
    queryKey: [GET_DESCRIPTION_ITEMS],
    queryFn: () => getDescriptionItems()
  });

  const isEqualToInitialState =
    selectedSwitches?.every(item =>
      itensDescricao?.find(itemDescript => itemDescript.id === item)
    ) && selectedSwitches.length === itensDescricao?.length;

  useEffect(() => {
    if (!itensDescricao) return setSelectedSwitches([]);
    setSelectedSwitches(itensDescricao.map(item => item.id));
  }, [itensDescricao]);

  useEffect(() => {
    setValueIsDifferentFromCurrent(!isEqualToInitialState);
  }, [isEqualToInitialState, setValueIsDifferentFromCurrent]);

  return (
    <OpenEditWrapper>
      <OpenEditTitleWrapper>
        <Title size="overline">editar diferenciais</Title>
        <Title variant="default" contrast="light">
          selecione os diferenciais do seu carro
        </Title>
      </OpenEditTitleWrapper>

      {isInitialLoading && <Loading />}

      <List>
        {data && selectedSwitches ? (
          data?.map(({ id, nome }) => (
            <ListItemModifier key={id}>
              <ListItem
                label={nome}
                variant="selector"
                initialValue={selectedSwitches?.includes(id)}
                radioValue={id}
                selectorName={nome}
                selectorVariant="switch"
                selectorOnChange={() => {
                  setSelectedSwitches(() => {
                    if (!selectedSwitches) {
                      return selectedSwitches;
                    }
                    if (selectedSwitches?.includes(id)) {
                      return selectedSwitches.filter(selected => selected !== id);
                    }
                    return [...selectedSwitches, id];
                  });
                }}
              />
            </ListItemModifier>
          ))
        ) : (
          <></>
        )}
      </List>

      {!(isInitialLoading && !!isEqualToInitialState) && (
        <SaveFormContent
          loading={loading}
          isDisabled={!!isEqualToInitialState}
          handleClick={() => {
            const selectedItems = data?.filter(item => selectedSwitches?.includes(item.id));
            setCurrentContent({
              veiculo: {
                itensDescricao: selectedItems
              }
            });
          }}
        />
      )}
    </OpenEditWrapper>
  );
}
